import React from 'react';

export default ({ className }: { className?: string }) => <div className={className}>
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M1.12183 1.12194L13.0018 13.0019" stroke="#A9B3C5" strokeLinecap="round"/>
<path d="M12.8799 1L0.999883 12.88" stroke="#A9B3C5" strokeLinecap="round"/>
</svg></div>;
